import React from "react";

import { Error } from "@churchofjesuschrist/eden-alert";
import {Search as SearchBox} from "@churchofjesuschrist/eden-search-box";
//import SearchBox from "@churchofjesuschrist/eden-search-box";

class GenericSearch extends React.Component {
  state = {
    search: "",
    alertDismissed: false,
  };
  inputRef = React.createRef();
  timeout = null;

  fieldChanged = (e) => {
    const elem = e.target;
    this.setState({
      [elem.name]: elem.value,
    });
  };

  dismissAlert = () => {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.setState({ alertDismissed: true });
  };

  //NOTE: this component expects strings to be passed in already flattened
  //to have go, invalid, notFound, placeholder populated from whatever string group meets a specific context
  //so this one still needs to follow this pattern and not use our helper
  manageStrings = (strings) => {
    const fallback = {
      go: "!go!",
      invalid: "!invalid!",
      notFound: "!notFound!",
      placeholder: "!placeholder!",
    };

    //merge fallback in to strings with strings taking precedent
    return { ...fallback, ...strings };
  };
  conditionalInitTimeout = () => {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    const { notFound, alertSeconds } = this.props;
    const { alertDismissed } = this.state;
    const showAlert = notFound && !alertDismissed;

    if (showAlert && alertSeconds) {
      const time = alertSeconds * 1000;
      this.timeout = setTimeout(this.dismissAlert, time);
    }
  };

  componentDidMount = () => {
    this.conditionalInitTimeout();
  };
  componentDidUpdate = () => {
    this.conditionalInitTimeout();
  };
  componentWillUnmount = () => {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  };
  onSearchSubmitted = (e) => {
    e.preventDefault();
    const form = e.target;
    const searched = form.search.value;
    const { onSearch = () => {} } = this.props;

    //give a callback that can clear the search value if a parent component uses it.
    onSearch(searched, () => {
      form.search.value = "";
    });
  };
  render() {
    //We have to destructure some things out so that ...others doesn't create a react warning
    let {
      strings = {},
      // eslint-disable-next-line no-unused-vars
      onSearch,
      notFound,
      pattern,
      // eslint-disable-next-line no-unused-vars
      alertSeconds,
      ...others
    } = this.props;
    //they may have passed in a strings obj without a shared
    strings = this.manageStrings(strings);

    const { alertDismissed } = this.state;

    const showAlert = notFound && !alertDismissed;

    return (
      <React.Fragment>
        <SearchBox
          {...others}
          name="search"
          ref={this.inputRef}
          pattern={pattern}
          placeholder={strings.placeholder}
          submitButtonLabel={strings.go}
          onSubmit={this.onSearchSubmitted}
        />
        {showAlert ? (
          <Error onClose={this.dismissAlert}>{strings.notFound}</Error>
        ) : null}
      </React.Fragment>
    );
  }
}

export default GenericSearch;
